// extracted by mini-css-extract-plugin
export default {"root":"_1Vdeb","content":"_2y3TN"};